import { render, staticRenderFns } from "./zgsc.vue?vue&type=template&id=0988de3a&scoped=true&"
import script from "./zgsc.vue?vue&type=script&lang=js&"
export * from "./zgsc.vue?vue&type=script&lang=js&"
import style0 from "./zgsc.vue?vue&type=style&index=0&id=0988de3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0988de3a",
  null
  
)

export default component.exports